























import { Component, Vue } from 'vue-property-decorator';
import { FirebaseModule } from '@/module/firebase';

@Component
export default class Signin extends Vue {
  private username: string = '';
  private password: string = '';
  private firebaseModule = new FirebaseModule();

  public signIn() {
    this.firebaseModule.signIn(this.username, this.password);
  }
  public signInTwitter() {
    this.firebaseModule.signInTwitter();
  }
}
